import { Alert, AlertDescription } from "@nimit9/signet-ui/components/alert"
import { Button } from "@nimit9/signet-ui/components/button"
import { useState } from "react"
import { useForceResetLearning } from "@/hooks/use-learning"

/**
 * Shown when the stored household learning bag cannot be decrypted. Learned
 * aliases/rules are left untouched until the user explicitly confirms a reset.
 */
export function LearningUnreadableAlert() {
  const [confirming, setConfirming] = useState(false)
  const reset = useForceResetLearning()

  return (
    <Alert variant="destructive" data-testid="learning-unreadable">
      <AlertDescription>
        <p>
          Your saved categorisation learning can't be read, so it won't be changed. Auto-learning is
          paused until this is resolved.
        </p>
        {reset.isError && <p className="mt-1">{(reset.error as Error).message}</p>}
        {confirming ? (
          <div className="mt-2 flex items-center gap-2">
            <span className="text-[12px]">
              This permanently erases all learned aliases and rules.
            </span>
            <Button
              size="sm"
              variant="destructive"
              disabled={reset.isPending}
              onClick={() => reset.mutate((bag) => bag, { onSuccess: () => setConfirming(false) })}
            >
              Confirm reset
            </Button>
            <Button size="sm" variant="outline" onClick={() => setConfirming(false)}>
              Cancel
            </Button>
          </div>
        ) : (
          <Button size="sm" variant="outline" className="mt-2" onClick={() => setConfirming(true)}>
            Reset learning data
          </Button>
        )}
      </AlertDescription>
    </Alert>
  )
}
